class companiesCreateController{
  constructor(
    $companies,
    CONFIG,
    $state
  ){

    'ngInject';

    this.$companies = $companies;
    this.$state     = $state;
    this.$companies.setUri( `${CONFIG.API.companies}` );

  }
  $onSubmit(){
    this.$companies.create( this.company )
      .then( company => this.$state.go('adminCompanies.detail', {id: company.id}));
  }
}

export default companiesCreateController;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/companies/companies-create/companies-create.controller.js
 **/